import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function IconButton(): Components {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {}
      }
    }
  };
}
